import { useState } from 'react'
import { Button } from '../../../components';
import { authStaff, generateRefNumber, formatToInternational } from '../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { fetchRequests } from '../../../Requests/getRequests';
import { useNavigate } from 'react-router-dom';
import { show } from '../../../slices/toastSlice';

function PreApproval({ loan, setConfirmedClient }) {

    const accessToken = useSelector(selectAccessToken);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [client, setClient] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [approvalProcessing, setApprovalProcessing] = useState(false);
    const [confirmApproval, setConfirmApproval] = useState(false);

    // const [mandateId, setMandateId] = useState(null);

    const [counter, setCounter] = useState(30);
    const [success, setSuccess] = useState(null);

    const verifyClient = async() => {
        setProcessing(true);
        
        let data = {
            phone : loan?.phone,
            network : "mtn",
        }

        let url = `/payments/staff/verify-client`;
        let headers = authStaff(accessToken);

        let res = await fetchRequests(url, "GET", headers, data, {});
        setProcessing(false);

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : res?.err
            }))
            return;
        }

        setClient(res);
        setSuccess(true);
    }


    const requestApproval = async() => {
        setApprovalProcessing(true);

        let data = {
            client_phone : formatToInternational(loan?.phone),
            amount_to_debit : loan?.accountInfo?.premium,
            frequency_type : loan?.paymentPlan,
            frequency : 1,
            start_date : loan?.paymentDates[0],
            end_date : loan?.paymentDates[loan?.paymentDates.length - 1],
            debit_day : Number(loan?.paymentDates[0].split("-")[2]),
            network : `${loan?.preferredNetwork.toUpperCase()}`,
            third_party_reference_no : generateRefNumber(),
            customer_name : `${loan?.signedName}`,
            customer_email : `${loan?.client.email}`,
        }

        let url = `/payments/npontu/mandates`;
        let headers = authStaff(accessToken);

        let res = await fetchRequests(url, "POST", headers, {}, data);
        setApprovalProcessing(false);

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : res?.err
            }))
            return;
        }
        
        if(res?.data){
            dispatch(show({
                type : "success",
                state : true,
                message : `Approval request sent successfully to client's phone number.`
            }))

            const newMandateId = res?.data?.mandateId;
            // setMandateId(newMandateId);

            setConfirmApproval(true);

            // timer to enable verify button after 30 seconds
            const startTimer = () => {
                const timer = setInterval(() => {
                    setCounter(prevCounter => prevCounter - 1);
                }, 1000);

                return () => {
                    clearInterval(timer);
                };
            };
            
            if(counter > 0){
                startTimer();
            }

            // check for approval status after 30 seconds
            setTimeout(() => {
                checkApprovalStatus(newMandateId);
            }, 30000)
        }
    }

    const checkApprovalStatus = async(mandateId) => {
        let url = `/payments/npontu/mandate`;
        let headers = authStaff(accessToken);
        let params = {
            id : mandateId,
        }

        let res = await fetchRequests(url, "GET", headers, params, {});

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : res?.err
            }))
            return;
        }

        if(res?.data?.status === "pending"){
            setCounter(30);
            setTimeout(() => {
                checkApprovalStatus(mandateId);
            }, 30000);
            return;
        }

        if(res?.data?.status === "FAILED"){
            setCounter(30);
            dispatch(show({
                type : "error",
                state : true,
                message : `Client did not approve the request to auto-debit their account.`
            }))
            return;
        }

        setConfirmedClient(true);
        dispatch(show({
            type : "success",
            state : true,
            message : `Client approved the request to auto-debit their account. Fund disbursement can proceed.`
        }))
        client.approval = `Confirmed by Client`;

    }


    return (
        <div className='p-1 flex flex-col'>
            <div className='bg-yellow-200 p-4 rounded-md text-yellow-700'>
                Verify client's details with Telco <span className='font-bold'>(MTN)</span> and confirm client's approval to proceed with disbursement
            </div>

            <div className='inline-flex items-center w-full space-x-4 mt-4'>
                <Button 
                    btnText={"Verify Client"}
                    btnType="button"
                    btnClasses={"form-button w-32"}
                    disabled={processing}
                    btnFunction={verifyClient}
                    processing={processing}
                />

                {success && (
                    <>
                    <Button 
                        btnText={`Request Approval`}
                        btnType="button"
                        btnClasses={"cancel-button w-52"}
                        disabled={!client || approvalProcessing}
                        btnFunction={requestApproval}
                        processing={approvalProcessing}
                    />

                    {(confirmApproval && counter > 0) && (
                        <p className='ml-3'>
                            Checking the status of the client's approval in <span className='font-bold'>{counter}</span> seconds...
                        </p>
                    )}
                    </>   
                )}
            </div>

            <div className='mt-8'>
                <h5 className="font-bold mb-3 underline">
                    Details from Telco (MTN)
                </h5>
                <ul>
                    <li>
                        Full name : 
                        <span className='font-bold'>
                            &nbsp;{client?.given_name} {client?.family_name}
                        </span>
                    </li>
                    {/* <li>
                        Date of birth : 
                        <span className='font-bold'>
                            &nbsp;{client && dateToHumanFormat(client?.birthdate)}
                        </span>
                    </li> */}
                    <li>
                        Status of approval : 
                        <span className='font-bold'>
                            &nbsp;{client?.approval}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default PreApproval